export default "__VITE_ASSET__B0Lswx1K__"